import React from 'react'

interface Props {
  className?: string
}

// Tabler "circles" icon (react-icons TbCircles), inlined as SVG markup so the
// @rolebase/graph package stays dependency-free (no react-icons; React is a
// peer only) and renders identically in the interactive, static and SSR/PDF
// exports. stroke="currentColor" makes it follow the title color.
export default function CirclesGlyph({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable={false}
    >
      <path d="M12 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
      <path d="M6.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
      <path d="M17.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
    </svg>
  )
}
